import { IContent } from "@kunduz/data-access-cms-api";
import Link from "next/link";
import { MobileNavMenu } from "@kunduz/ui-components";
import { getCmsIcon } from "../static/iconMappings";
import { trackEventNext } from "@kunduz/utility-analytics";
import styles from "./cmsMobileNavItems.module.scss";

export const CmsMobileNavItems = (props: {
  iconColor: string;
  cmsData?: IContent.HeaderItemsResponse["components"];
  lang: "tr" | "en";
}) => {
  const result: any[] = [];
  if (!props.cmsData) return result;

  function handleClicked(label?: string) {
    trackEventNext({ event: "Navbar Button Clicked", label });
  }

  for (let i = 0; i < props.cmsData.length; i++) {
    const component = props.cmsData[i];

    const Icon = component.data.icon
      ? getCmsIcon(component.data.icon)
      : undefined;

    switch (component.type) {
      case "headerbuttoncomponent":
        switch (component.data.type) {
          case "gradient":
            result.push(
              <Link
                key={`mobile_${component.data.label}`}
                href={component.data.url || "#"}
                className={styles.gradientButton}
                target={component.data.target || "_self"}
                onClick={() => handleClicked(component.data.label)}
              >
                {component.data.label}
              </Link>,
            );
            break;
          case "primary":
            result.push(
              <Link
                key={`mobile_${component.data.label}`}
                href={component.data.url || "#"}
                className={styles.primaryButton}
                target={component.data.target || "_self"}
                onClick={() => handleClicked(component.data.label)}
              >
                {component.data.icon ? <Icon viewBox="0 0 24 24" /> : undefined}
                {component.data.label}
              </Link>,
            );
            break;
          case "secondary":
            result.push(
              <Link
                key={`mobile_${component.data.label}`}
                href={component.data.url || "#"}
                className={styles.secondaryButton}
                target={component.data.target || "_self"}
                onClick={() => handleClicked(component.data.label)}
              >
                {component.data.icon ? <Icon viewBox="0 0 24 24" /> : undefined}
                {component.data.label}
              </Link>,
            );
            break;
          case "link":
            result.push(
              <Link
                key={`mobile_${component.data.label}`}
                href={component.data.url || "#"}
                className={styles.linkButton}
                target={component.data.target || "_self"}
                onClick={() => handleClicked(component.data.label)}
              >
                {component.data.icon ? <Icon viewBox="0 0 24 24" /> : undefined}
                {component.data.label}
              </Link>,
            );
            break;
          case "tertiary":
            result.push(
              <Link
                key={`mobile_${component.data.label}`}
                href={component.data.url || "#"}
                className={styles.tertiaryButton}
                target={component.data.target || "_self"}
                onClick={() => handleClicked(component.data.label)}
              >
                {component.data.icon ? <Icon viewBox="0 0 24 24" /> : undefined}
                {component.data.label}
              </Link>,
            );
            break;

          default:
            break;
        }
        break;

      case "headermenucomponent":
        result.push(
          <MobileNavMenu
            key={i}
            menus={[
              {
                title: component.data.title || "",
                items: component.data.childs?.map((child) => {
                  const MenuIcon = child.icon
                    ? getCmsIcon(child.icon)
                    : undefined;

                  return {
                    title: child.title,
                    url: child.url || "#",
                    desc: child.description,
                    icon: child.icon ? (
                      <MenuIcon color={props.iconColor} />
                    ) : undefined,
                    badgeText: child.badge_text,
                    badgeColor: child.badge_type,
                    onClick: () => handleClicked(child.title),
                  };
                }) as any,
                type: component.data.type as any,
              },
            ]}
            lang={props.lang}
          />,
        );
        break;

      default:
        break;
    }
  }

  return result;
};
